// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.HistoricalPointInTime
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { KendoObservableObjectProxy } from "abweb/dto/kendo/KendoObservableObjectProxy";
export class HistoricalPointInTimeBase extends KendoObservableObjectProxy {
  /** Do NOT invoke directly, instead use strongly typed createHistoricalPointInTimeBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.HistoricalPointInTime";
  }
  initFromJson(json, deserializeContext) {
    this.initHistoricalPointInTime(json.active != null ? json.active : null, json.datetime != null ? new Date(json.datetime) : null, json.version != null ? json.version : null);
  }
  initHistoricalPointInTime(active, datetime, version) {
    this.initKendoObservableObjectProxy();
    this._active = active;
    this._datetime = datetime;
    this._version = version;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    retVal["active"] = this._active;
    if (this._datetime != null) {
      retVal["datetime"] = this._datetime;
    }
    if (this._version != null) {
      retVal["version"] = this._version;
    }
    return retVal;
  }
  get active() {
    return this._active;
  }
  set active(value) {
    this._active = value;
  }
  get datetime() {
    return this._datetime;
  }
  set datetime(value) {
    this._datetime = value;
  }
  get version() {
    return this._version;
  }
  set version(value) {
    this._version = value;
  }
}
//# sourceMappingURL=HistoricalPointInTimeBase.js.map
